/**
 * Подписи к состоянию фотографии профиля (U-04, U-09).
 *
 * Изменение v1.11: фото публикуется сразу, и «на проверке» у него больше нет —
 * остаётся единственное состояние, о котором нужно сказать владельцу: фото сняли
 * по жалобе или выборочной проверке, и в анкете его не показывают.
 */
import type { ProfilePhoto } from '@shared/api/types'
import { MODERATION_REASON_TEXT } from '@shared/media/limits'

export const PHOTO_REJECTED_LABEL = 'Не показывается'

/** Причина отклонения человеческим языком; `null`, если фото показывается. */
export function photoRejectionText(photo: ProfilePhoto): string | null {
  if (photo.state !== 'rejected') return null
  return MODERATION_REASON_TEXT[photo.rejection_reason ?? 'other'] ?? MODERATION_REASON_TEXT['other']!
}
